
<template>
  <!--新增分类-->
  <x-addEdit
    ref="form"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import fetchSelect from '@/utils/mixins/fetchSelect.js';
export default {
  mixins: [fetchSelect],
  name: 'aadCategory',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入类目名称' },
          { pattern: this.REG.name, message: this.MESSAGE.name }
        ]
      },
      parentId: { rules: [] },
      mark: {
        validateTrigger: 'blur',
        rules: [{pattern: this.REG.code, message: this.MESSAGE.code}]
      },
      imagesId: { rules: [] },
      description: { rules: [{ min: 2, max: 20, message: '描述为2-20个字' }] },
      status: { initialValue: 1, rules: [] }
    };
    return {
      formList: [
        {
          label: '类目名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入类目名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '上级类目',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择上级类目',
          changeOnSelect: true,
          disabled: false,
          fieldNames: {label: 'label', value: 'value', children: 'children'},
          props: ['parentId', decoratorOptions.parentId]
        },
        {
          label: '标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入标识符',
          disabled: false,
          props: ['mark', decoratorOptions.mark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'imagesUrl',
            iconName: 'imagesUrl',

            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['imagesId', decoratorOptions.imagesId]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        title: '',
        parentId: '',
        mark: '',
        imagesId: '',
        description: '',
        status: ''
      },
      addParam: {
        url: '/category',
        reqHandle: this.reqHandle, // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/category/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/category/',
        resHandle: this.detailResHandle
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.setApiUrl();
    if (this.$route.query.parentId) {
      this.formList[1].disabled = true;
      this.getSelect();
    }
    !this.$route.query.id && this.getSelect();
  },
  methods: {
    getSelect (parentId) {
      this.$get({
        url: '/category/treeselect'
      }).then(({data}) => {
        if (parentId) {
          if (!Array.isArray(parentId)) {
            (parentId = parentId.split(','));
          };
          let startIndex = parentId.length;
          data.forEach((el) => {
            let num = 0;
            startIndex === num && (el.disabled = true);

            el.children && el.children.forEach((item) => {
              let num = 1;
              startIndex === num && (item.disabled = true);

              // item.children && item.children.forEach((part) => {
              //   let num = 2;
              //   startIndex === num && (part.disabled = true);
              // });
            });
          });
        }
        if (this.$route.name === 'addDocCate') {
          let arr = [];
          data.forEach(item => {
            if (item.children) {
              item.children.forEach(el => {
                if (el.children) delete el.children;
              });
            }
            arr.push(item);
          });
        }
        this.formList[1].options = data;
        if (this.$route.query.parentId) {
          this.$refs.form.form.setFieldsValue({
            parentId: this.$route.query.parentId
          });
          // empty.$emit('setForm', {'parentId': this.$route.query.parentId});
        }
      });
    },
    setApiUrl () {
      let arr = ['addParam', 'editParam', 'detailParam'];
      arr.forEach((el) => {
        this[el].url = this.$store.state.categoryAddApi[this.$route.name];
        if (el !== 'addParam') {
          this[el].url = this.$store.state.categoryAddApi[this.$route.name] + '/';
        }
      });
    },
    reqHandle (param) {
      param.parentId = Array.isArray(param.parentId) ? param.parentId.join() : '';
      return param;
    },
    detailResHandle (data) {
      if (data.mark) {
        this.formList[2].disabled = true;
      }
      this.getSelect(data.parentIds);
      return {
        parentId: data.parentIds
      };
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
